import { validateCpfAndCnpj } from 'v2/helpers/cpfCnpj';
import * as Yup from 'yup';

const CreateAndEditSchema = Yup.object().shape({
  customer_name: Yup.string().required('Por favor insira o nome').min(5, 'Insira pelo menos 5 caracteres'),
  customer_email: Yup.string().required('Por favor insira o e-mail').email('Insira um e-mail válido'),
  customer_document: Yup.string().required('Por favor insira o CPF/CNPJ').test('invalid', 'Documento é inválido', validateCpfAndCnpj),
});

export default CreateAndEditSchema;
